import { createRouter, createWebHistory } from 'vue-router'

import About from '../views/About'
import Home from '../views/Home'
import OpenTasks from '../views/OpenTasks'

const routes = [
  {
    path: '/alltasks',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/',
    name: 'Open Tasks',
    component: OpenTasks
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
